import { FC } from "react";

import { usePageContext } from "@ryde/redux";
import { isEntityWithoutBulkActions } from "@ryde/shared";

import { BulkGridSelectionControl } from "../elements";
import { PanelTopStatCommon } from "../panels-stat";
import { PanelTopSearchMobileLineStyled } from "./panel-top.styled";

/** Mobile header second line: bulk select + grid stats (desktop uses {@link PanelTop}). */
export const PanelTopSearchMobileLine: FC = () => {
  const { entity } = usePageContext();
  const showBulkGridSelection = !isEntityWithoutBulkActions(entity);

  return (
    <PanelTopSearchMobileLineStyled>
      {showBulkGridSelection && <BulkGridSelectionControl />}
      <div className="panelTopRight">
        <PanelTopStatCommon embeddedInSearchMobileLine />
      </div>
    </PanelTopSearchMobileLineStyled>
  );
};
